module.exports = __webpack_public_path__ + "img/07.f69dd915.svg";